const autoNgTemplateLoaderTemplate1 = require('./createCustomTemplateView.html');

import CreateCustomTemplateViewController from './createCustomTemplateViewController.js';

angular.module('portainer.app').component('createCustomTemplateView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: CreateCustomTemplateViewController,
});
